module.exports = __webpack_public_path__ + "static/media/abstract4.b8ef214f.jpg";